import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-prosigliere-blue"></div>
      </div>
    );
  }

  // If not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" />;
  }

  // If user hasn't completed onboarding and not already on onboarding page, redirect to onboarding
  if (user.onboardingCompleted !== true && location.pathname !== '/new-onboarding') {
    return <Navigate to="/new-onboarding" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
